// extracted by mini-css-extract-plugin
export default {"wrapperInner":"styles_wrapperInner__GHOnb"};